import InvoiceGenerator from '@/components/InvoiceGenerator';

const InvoicesPage = () => {
  return (
    <div className="app-page invoices-page" data-testid="invoices-page">
      <InvoiceGenerator />
    </div>
  );
};

export default InvoicesPage;
